// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"423":"b4b8b482","433":"88f6b3fa","913":"6fca3f34"}[chunkId] + ".chunk.js";
};